<template>
  <div class="container" v-cloak>
    <!-- 贷款申请已通过，等待资方电话复审 -->
    <div class="top-con u-text-center">
      <img class="page-bg" src="../../assets/images/entryThemeOne/page-bg.png" alt="" />
      <!-- 夜间量展示的文案 -->
      <template v-if="hasPushSuccess == 2">
        <div class="top-con-tit">
          <img src="../../assets/images/img_tel.png" />
        </div>
        <h4>请等待客户经理来电</h4>
        <p>
          第三方客户经理将在次日9:00~18:00通过电话为
          <br />您提供借款审批服务，请注意接听，配合借款审批
        </p>
      </template>
      <!-- 普通文案 -->
      <template v-else>
        <div class="top-con-tit-normal">
          <!-- <img src="../../assets/images/image_orange/result/top_phone.png" /> -->
          <img src="../../assets/images/entryThemeOne/header-line-white.png" />
          <h4 v-if="$route.query.insuranceResultKey && String($route.query.hasPushSuccess) === '0'">
            贷款申请结果
          </h4>
          <h4 v-else>恭喜您！贷款申请已成功</h4>
          <img class="right" src="../../assets/images/entryThemeOne/header-line-white.png" />
        </div>
        <!-- <h4>贷款申请已成功，等待资方电话复审</h4> -->
        <!-- <p>
          首次借款需资方客户经理电话联系您确认相关信息,<br />
          请注意接听!
        </p> -->
      </template>
    </div>

    <div class="mechanism-con">
      <!-- <div class="line" /> -->
      <div class="mechanism-info">
        <!-- <div class="linear-gradient" /> -->
        <!-- 机构信息 -->
        <div class="pr">
          <!-- 未匹配上机构 -->
          <div
            class="u-flex-1 u-text-center mechanism-info-div"
            v-if="applyId === '0' || !productName"
          >
            <div class="origan-desc">— 请注意接听该机构电话 —</div>
            <div class="u-flex u-row-between u-col-center">
              <p class="u-flex-1 origan-right" v-if="applyId === '0' || !productName">
                正在匹配中...
              </p>
            </div>
            <!-- <img
              class="top-msg"
              src="../../assets/images/image_orange/result/top_msg.png"
            />
            <div class="top-msg-title">等待资方电话复审</div>
            <div class="origan-desc">
              首次借款需资方客户经理电话联系您确认相关信息
            </div>
            <div class="bottom-desc">*为保证电话复审通过，请你注意接听来电</div>
            <div class="product-info">
              <div class="product-info-item">
                <div class="product-infoitem-label">产品名称：</div>
                <div>{{ productName }}</div>
              </div>
              <div class="product-info-item">
                <div class="product-infoitem-label">最高可借金额：</div>
                <div>¥ {{ creditAmount }}</div>
              </div>
              <div class="product-info-item">
                <div class="product-infoitem-label">公司名称：</div>
                <div>{{ institutionName }}</div>
              </div>
            </div> -->
          </div>

          <!-- 匹配上机构 -->
          <template v-else>
            <div class="mechanism-info-div-success">
              <img
                class="success-phone"
                src="../../assets/images/image_orange/result/top_msg.png"
                alt=""
              />
              <div class="success-title">等待资方电话复审</div>
              <div class="success-desc">
                首次借款需资方客户经理电话联系您确认相关信息请注意接听!
              </div>
              <div class="success-tips">*为保证电话复审通过，请你注意接听来电</div>
              <div class="success-info">
                <!-- <div class="success-info-name">
                  <img
                    :src="
                      productLogo
                        ? productLogo
                        : '../../assets/images/img_mechanism.png'
                    "
                  />
                  <span>{{ productName }}</span>
                </div> -->
                <div class="success-info-basic" v-if="institutionName">
                  <div class="success-info-basic-label">产品名称：</div>
                  <div>{{ productName }}</div>
                </div>
                <div class="success-info-basic">
                  <div class="success-info-basic-label">最高可借金额：</div>
                  <div>¥ {{ creditAmount }}</div>
                </div>
                <div class="success-info-basic" v-if="institutionName">
                  <div class="success-info-basic-label">公司名称：</div>
                  <div>{{ institutionName }}</div>
                </div>
                <!-- 年化利率严格使用结果接口返回值，避免前端固定口径与最终审批信息不一致。 -->
                <div class="success-info-basic" v-if="annualRate">
                  <div class="success-info-basic-label">年化利率(单利)：</div>
                  <div>{{ annualRate }}(已包含全部息费)</div>
                </div>
              </div>
            </div>
          </template>

          <!-- 客服信息(有机构不一定有客服电话) -->
          <!--          <div-->
          <!--            class="customer-service-div"-->
          <!--            v-if="!(applyId === '0' || !productName)"-->
          <!--          >-->
          <!--            <template v-if="callMobile">-->
          <!--              <p>将由该客户经理为您服务</p>-->
          <!--              <div class="u-flex u-row-between">-->
          <!--                <div class="u-flex">-->
          <!--                  <img src="../../assets/images/icon_avatar.png" />-->
          <!--                  <h5>{{ callMobile }}</h5>-->
          <!--                </div>-->
          <!--                <span>请注意接听该号码来电</span>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--            &lt;!&ndash; 有机构但是没有客服电话的文案 &ndash;&gt;-->
          <!--            <p v-else class="call-mobile-tips">-->
          <!--              * 为保证电话复审通过，请你注意接听来电-->
          <!--            </p>-->
          <!--          </div>-->
          <!-- 我知道了 -->
          <van-button
            class="download-app-btn"
            type="default"
            @click="onUserConfirmQuotaClick"
            block
            v-if="isRedirectProductsPage == 1"
          >
            <span>确认额度</span>
          </van-button>
          <van-button
            class="download-app-btn"
            type="default"
            @click="onUserConfirmQuotaClick"
            block
            v-if="isRedirectProductsPage == 0"
          >
            <span>去app确认额度</span>
          </van-button>
        </div>

        <!-- 贷款流程 -->
        <div
          v-if="!($route.query.insuranceResultKey && String($route.query.hasPushSuccess) === '0')"
          class="pagecard"
        >
          <h4>贷款流程</h4>
          <ul class="u-flex u-text-center pagecard-process" style="margin-top: 0.5rem">
            <li class="loan-process-li u-flex-1">
              <img src="../../assets/images/image_orange/result/icon_safe.png" />
              <h6>风控系统审核</h6>
              <div class="u-flex u-row-center">
                <!-- <img
                  class="icon-img"
                  src="../../assets/images/image_orange/result/icon_pass.png"
                /> -->
                <span class="green">已通过</span>
              </div>
            </li>
            <li class="line pr">
              <img class="pa" src="../../assets/images/entryThemeOne/step_arrow.png" />
            </li>
            <li class="loan-process-li u-flex-1">
              <img src="../../assets/images/image_orange/result/icon_phone.png" />
              <h6>电话复审</h6>
              <div class="u-flex u-row-center">
                <!-- <img
                  class="icon-img"
                  src="../../assets/images/image_orange/result/icon_dot_orange.png"
                /> -->
                <span class="yellow">进行中</span>
              </div>
            </li>
            <li class="line pr">
              <img class="pa" src="../../assets/images/entryThemeOne/step_arrow.png" />
            </li>
            <li class="loan-process-li u-flex-1">
              <img src="../../assets/images/image_orange/result/icon_money.png" />
              <h6 style="color: #c2c3c4">申请提现</h6>
              <div class="u-flex u-row-center">
                <!-- <img
                  class="icon-img"
                  src="../../assets/images/image_orange/result/icon_dot_gray.png"
                /> -->
                <span class="default">等待电话复审</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- 展示条件：1.根据【管理后台 渠道管理-着陆页配置】配置是否推跳转贷超列表 -->
        <!-- 配置跳转贷超列表且有产品信息时展示；不推荐和无可推荐产品时不展示 -->
        <!-- 2.若配置产品用户均已点击完成则专项产品池模块隐藏 -->
        <!-- 排序：按照价格排序，价格高则展示在第一位，若价格相同则权重，权重相同则随机展示，需通过“用户ID”保证“同一用户点击过该产品后则不再显示” -->
        <!-- 保险结果只在本次投保成功返回并携带结果索引时展示，普通进件结果不受影响。 -->
        <InsuranceResult />
        <div class="pagecard" v-if="isRedirectProductsPage == 1 && productList.length > 0">
          <h4>第三方金融产品</h4>
          <!-- 轮播规则： -->
          <!-- 自动轮播，默认开启自动轮播功能，轮播间隔时间3秒， -->
          <!-- 手动滑动：用户可通过左右滑动操作切换轮播图片，用户手动滑动后暂停轮播一段
时间(暂停10秒后继续轮播 -->
          <!-- 点击跳转对应H5页面 -->
          <swiper :options="swiperOptions" ref="mySwiper">
            <swiper-slide v-for="(item, index) in productList" :key="index">
              <div class="pagecard-product" :class="[productList.length == 1 ? '' : 'swiperPb']">
                <div class="pagecard-product-left">
                  <div class="pagecard-product-left-top">
                    <div class="pagecard-product-left-top-l">
                      <img
                        class="pagecard-product-logo"
                        :src="item.imgUrl ? item.imgUrl : '../../assets/images/img_mechanism.png'"
                      />
                      <div>
                        <div class="pagecard-product-name">
                          {{ item.productName }}
                          <van-tag
                            v-for="(tag, i) in item.tagList"
                            :key="i"
                            color="#FFF4EF"
                            text-color="#FFB481"
                            style="
                              margin-right: 0.06rem;
                              margin-bottom: 0.06rem;
                              border: 1px solid #ffb481;
                            "
                          >
                            {{ tag }}
                          </van-tag>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pagecard-product-left-bottom">
                    <div class="pagecard-product-left-bottom-item1">
                      <div class="item1-tit">可借额度范围（元）</div>
                      <div class="item1-text">￥{{ item.minAmount }}~{{ item.maxAmount }}</div>
                    </div>
                    <van-button class="pagecard-product-btn" @click="handleProductClick(item, 15)"
                      >立即申请</van-button
                    >
                  </div>
                  <!-- 贷超产品最大利率缺失时才按 24% 兜底。 -->
                  <div class="pagecard-product-left-rate">
                    综合年利率：{{ item.minLoanRate }}%~{{ item.maxLoanRate || 24 }}%
                  </div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination" v-if="productList.length > 1"></div>
          </swiper>
        </div>
      </div>
    </div>

    <!-- 下载APP查看实时放款进度 -->
    <div class="downloadBtnContainer" v-if="isH5DownloadAppShow == 1">
      <!-- && isRedirectProductsPage === 0 -->
      <van-button type="default" block class="download-app-btn" @click="handleDownload">
        <span class="span">下载闪借花APP</span>领取额度
      </van-button>
    </div>
  </div>
</template>

<script>
import InsuranceResult from '@/components/InsuranceResult'
import * as API_Common from '@/api/common.js'
import Cookies from 'js-cookie' // 需要安装 js-cookie 或使用其他 cookie 库
import resultSuccessBuriedMixin from '@/mixins/resultSuccessBuriedMixin.js'
export default {
  components: { InsuranceResult },
  name: 'resultOrange',
  mixins: [resultSuccessBuriedMixin],
  data() {
    return {
      source: this.$route.query.source || '', // 渠道标识
      loanAmount: this.$route.query.loanAmount, // 金额
      applyId: this.$route.query.applyId, // 进件申请id(0为不成功，无需调用接口查询机构信息,不为0需要查询)
      isRedirectProductsPage: parseInt(this.$route.query.isRedirectProductsPage), // 标识是否是贷超流程1是 0否
      productLogo: '', // 机构ICON
      productName: '', // 机构名称
      callMobile: '', // 客服电话
      downAppUrl: undefined, // 下载地址
      apiReqType: this.$route.query.apiReqType,
      isH5DownloadAppShow: parseInt(this.$route.query.isH5DownloadAppShow),
      hasPushSuccess: null, // 返回2时展示“请等待客户经理来电”的提示
      swiperOptions: {
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 手动滑动后不禁止自动播放
        },
        on: {
          touchEnd: function () {
            // 手动滑动结束后，先停止自动播放
            this.autoplay.stop()
            // 10秒后重新开始自动播放
            setTimeout(() => {
              this.autoplay.start()
            }, 10000)
          },
        },
      }, // 轮播图配置
      productList: [], // 产品列表
      creditAmount: 0, // 最高可借金额
      institutionName: '', // 机构名称
      annualRate: '', // 结果接口返回的年化利率，空值时不展示
      tid: this.$route.query.downPageUrlTid || '', // 进件申请id
      jwt: this.$route.query.jwt || '', // 从URL获取JWT
    }
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'resultOrangeThemeOne'
  },
  mounted() {
    // let isWeixin = this.isWeixin();
    // if (isWeixin) {
    //   this.showPop = true;
    // }
    // 处理JWT自动登录
    this.handleJwtLogin()
    // 如果进件申请id不为0则查询机构信息
    if (this.applyId && this.applyId !== '0') {
      this.getMechanismInfo()
    }

    this.getDownloadUrl()

    this.getProductList()
    // 新增根据source判断title是否展示湘江源小贷
    if (this.source == 'ceshi003') {
      document.title = '湘江源小贷'
    }
  },
  methods: {
    // 处理JWT登录
    handleJwtLogin() {
      // 如果有JWT，设置为token，实现免登录
      if (this.jwt) {
        console.log('JWT token found, setting cookie...')
        // 设置 Cookie 时必须指定 path: '/' 使其在整个域名下可访问
        Cookies.set('token', this.jwt, { path: '/' })

        // 使用 setTimeout 确保 Cookie 设置完成后再发送请求
        setTimeout(() => {
          //this.getUserInfo();
        }, 100)
      }
    },
    // 获取机构信息
    getMechanismInfo() {
      let obj = {
        applyId: this.applyId,
        apiReqType: this.apiReqType,
      }
      API_Common.getMechanismInfo(obj).then((res) => {
        if (res.code === 200) {
          // 进件是否推送成功;1:成功(会返回对应的产品信息)、0:失败(不会返回产品信息)
          if (res.data.hasPushSuccess === 1) {
            this.productName = res.data.productName
            this.productLogo = res.data.productLogo
            this.callMobile = res.data.callMobile
            this.creditAmount = res.data.creditAmount
            this.institutionName = res.data.institutionName
            this.annualRate = res.data.annualRate || ''
          }
          this.hasPushSuccess = res.data.hasPushSuccess
        } else {
          this.$toast(res.msg)
        }
      })
    },

    // 获取下载地址
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.source, true).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        } else {
          this.$toast.fail('获取下载地址失败,请重试')
        }
      })
    },

    // 获取产品列表
    getProductList() {
      let obj = {
        channelCode: this.source || '',
        // 分页信息
        pageNum: 1,
        pageSize: 8,
        showPage: 15,
      }
      API_Common.h5CpaProductAllPageList(obj).then((res) => {
        if (res.code === 200) {
          this.productList = res.data.productPageVO.list || []
          if (this.productList.length == 1 || this.productList.length == 0) {
            this.swiperOptions.loop = false
          } else {
            this.swiperOptions.loop = true
          }
        }
      })
    },
    // 新增方法：3秒后自动下载APP
    // 自动下载App方法
    autoDownloadApp() {
      // 判断是否在微信中（微信会屏蔽下载）
      if (this.isWeixin()) {
        this.$toast.clear()
        this.$toast('请在浏览器中打开此页面进行下载')
        return
      }

      // 模拟调用 index.html 中的 down() 方法
      // 由于跨文件无法直接调用，我们可以模拟其逻辑：
      // 1. 获取渠道参数
      // 2. 请求下载地址
      // 3. 跳转下载
      const source = this.source || ''

      // 显示加载状态
      this.$toast.loading({
        message: '获取下载地址中...',
        forbidClick: true,
      })

      // 使用相同的接口获取下载地址
      API_Common.getDownloadUrl(source, true)
        .then((res) => {
          this.$toast.clear()
          if (res.code === 200 && res.data && res.data.url) {
            console.log('获取下载地址成功:', res.data.url)
            // 直接跳转到下载地址
            window.location.href = res.data.url
          } else {
            this.$toast.fail(res.msg || '下载地址获取失败，请稍后重试')
          }
        })
        .catch((err) => {
          this.$toast.clear()
          console.error('获取下载地址失败:', err)
          this.$toast.fail('下载地址获取失败，请稍后重试')
        })
    },
    // 我知道了按钮点击
    handleIGotIt() {
      this.runHalfDownloadOrElse(() => {
        const timestamp = new Date().getTime()
        if (this.isRedirectProductsPage == 1) {
          window.location.href = `/productListOrange_themeOne.html?source=${this.source}&tsp=${timestamp}`
        } else {
          this.autoDownloadApp()
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$primaryColor: #e71a0f;

@keyframes shake {
  0% {
    transform: rotate(90deg) translateX(0);
  }

  25% {
    transform: rotate(90deg) translateX(-8px);
  }

  50% {
    transform: rotate(90deg) translateX(0);
  }

  75% {
    transform: rotate(90deg) translateX(2px);
  }

  100% {
    transform: rotate(90deg) translateX(0);
  }
}

.container {
  background: #f2f5fa;
  height: 100vh;
  overflow: auto;
  padding-bottom: 2rem;

  .top-con {
    position: relative;
    // margin: 0 0.3rem 0.3rem;
    padding: 0.44rem 0 3.36rem;
    background: linear-gradient(180deg, #ff7137 0%, #ff8a57 70.5%, #f8f8f8 100%);
    background-size: cover;
    background-position: top right;
    font-size: 0.24rem;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: normal;
    color: #fff;
    text-align: center;
    .page-bg {
      position: absolute;
      top: 0;
      right: 0;
      width: 2.4rem;
      height: 2.4rem;
      object-fit: cover;
    }
    &-tit {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 1.26rem;
        height: 1rem;
      }

      h4 {
        position: relative;
        top: 0.1rem;
        font-size: 0.36rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
      }
    }

    > h4 {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: normal;
      margin: 0.32rem 0 0.1rem;
    }

    > p {
      font-size: 0.2rem;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .top-con-tit-normal {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.32rem 0 0.1rem;
    > h4 {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
    }
    img {
      width: 0.6rem;
      margin: 0 0.2rem;
      &.right {
        transform: scale(-100%);
      }
    }
  }
  .mechanism-con {
    margin-top: -0.74rem;
    padding: 0 0.16rem;

    > .line {
      height: 0.2rem;
      background: $primaryColor;
      border-radius: 0.1rem;
    }

    > .mechanism-info {
      margin-top: -3.1rem;
      padding: 0 0.24rem;

      .mechanism-info-top {
        background-color: #ffffff;
        border-radius: 0.2rem;
      }

      //   .linear-gradient {
      //     height: 0.36rem;
      //     background: linear-gradient(180deg, #e67171, #ffffff);
      //   }
      .mechanism-info-div-success {
        margin-top: 10px;
        background: linear-gradient(180deg, #ffe6d7 0%, #fffefd 5.99%, #fffdfc 100%);
        border-radius: 0.2rem;
        position: relative;
        padding: 0.5rem 0 0;
        text-align: center;
        overflow: hidden;

        .success-phone {
          width: 1.2rem;
          height: auto;
          margin-bottom: 0.4rem;
        }

        .success-title {
          font-weight: 600;
          font-size: 0.36rem;
          color: #333333;
        }
        .success-desc {
          margin: 0.2rem 0;
          padding: 0 1.18rem;
          font-weight: 400;
          font-size: 0.22rem;
          color: #333333;
        }
        .success-tips {
          width: 5rem;
          margin: 0 auto;
          background: #fff4ef;
          border-radius: 0.12rem;
          font-size: 0.22rem;
          color: #ff5d0e;
          padding: 0.12rem 0 0.12rem 0.2rem;
        }

        .success-info {
          margin-top: 0.28rem;
          padding: 0 0.32rem 0;
          background: #fff6f3;
          .success-info-name {
            img {
              width: 0.42rem;
              height: 0.42rem;
              border-radius: 0.21rem;
              margin: 0.1rem;
            }

            span {
              font-weight: 600;
              font-size: 0.28rem;
              color: #333333;
            }
          }

          .success-info-basic {
            display: flex;
            justify-content: space-between;
            font-weight: 500;
            font-size: 0.25rem;
            color: #333333;
            line-height: 0.6rem;

            .success-info-basic-label {
              color: #9a9a9a;
            }
          }
        }
      }

      .mechanism-info-div {
        width: 100%;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.2rem;
        padding: 0.22rem 0.3rem 0.36rem;
        font-size: 0.22rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        color: #838f9f;
        .top-msg {
          width: 1.2rem;
          height: auto;
          margin-top: 0.5rem;
          margin-bottom: 0.2rem;
        }
        .creditAmount {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: normal;
          color: #e71a0f;
        }

        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          top: -50%;
          right: -42%;
          bottom: -50%;
          left: -42%;
          border-bottom: 0.02rem dashed #eee;
          transform: scale(0.5);
        }

        img {
          width: 0.8rem;
          height: 0.8rem;
          margin-right: 0.16rem;
          border-radius: 50%;
        }

        h4 {
          font-size: 0.32rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: normal;
          color: #192337;
        }

        span {
          font-size: 0.24rem;
          color: $primaryColor;
        }
        .top-msg-title {
          font-size: 0.32rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          color: #192337;
        }
        .origan-desc {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Thin;
          font-weight: normal;
          color: #111c31;
          line-height: 0.34rem;
          margin-top: 0.1rem;
          margin-bottom: 0.4rem;
        }
        .bottom-desc {
          width: 5rem;
          line-height: 0.5rem;
          margin: 0.2rem auto 0.2rem;
          background: #fff4ef;
          border-radius: 6px 6px 6px 6px;
          text-align: center;
          color: #ff5d0e;
        }
        .origan-right {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #111c31;
        }
      }

      .call-mobile-tips {
        font-size: 0.24rem;
        color: #f03d23;
        text-align: center;
      }

      .customer-service-div {
        padding: 0.22rem 0.3rem 0.36rem;
        border-top: 0.02rem dashed #eee;
        background: #ffffff;
        border-radius: 0 0 0.24rem 0.24rem;
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        color: #838f9f;
        // padding: 0.3rem 0.3rem 0.24rem;

        > div {
          margin-top: 0.24rem;
        }

        img {
          width: 0.6rem;
          height: 0.6rem;
          margin-right: 0.14rem;
          border-radius: 50%;
        }

        h5 {
          font-size: 0.28rem;
          font-family: PingFangSC, PingFangSC-Semibold;
          font-weight: bold;
          color: #192337;
        }

        span {
          color: #f03d23;
        }
      }

      .swiperPb {
        padding-bottom: 0.8rem !important;
      }

      .pagecard {
        margin-top: 0.16rem;
        background: linear-gradient(180deg, #fff9f6 0%, #ffffff 16.39%, #ffffff 100%);
        border-radius: 0.24rem;
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        padding: 0.32rem;
        box-sizing: border-box;

        > h4 {
          line-height: 0.2rem;
          font-size: 0.28rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          color: #333333;
          margin-top: 0.24rem;
          margin-bottom: 0.24rem;
          border-left: 0.08rem solid #ff6816;
          padding-left: 0.2rem;

          span {
            margin-left: 0.1rem;
            font-size: 0.24rem;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: normal;
            color: #666;
          }
        }

        &-process {
          background-color: #fff;
          border-radius: 0.3rem;
          margin-top: 0.3rem;

          .loan-process-li {
            > img {
              width: 0.64rem;
              height: 0.64rem;
            }

            .icon-img {
              width: 0.22rem;
              height: 0.22rem;
              border-radius: 50%;
              margin-right: 0.06rem;
            }

            h6 {
              font-size: 0.24rem;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: normal;
              color: #333333;
              margin: 0.2rem 0 0.2rem;
            }

            span {
              color: #7d8090;
              font-size: 0.22rem;
            }

            // span.green {
            //    color: #52c41a;
            // }

            // span.yellow {
            //    color: #f5a623;
            // }

            span.default {
              color: #c2c3c4;
            }

            p {
              margin-top: 0.2rem;
            }
          }

          .line {
            width: 0;

            > img {
              width: 0.6rem;
              height: 0.12rem;
              right: -0.3rem;
              top: -0.36rem;
            }
          }
        }

        &-product {
          margin-top: 0.24rem;
          //   border-radius: 0.4rem;
          background: url('../../assets/images/image_orange/result/pro_bg.png') no-repeat;
          background-size: 100% 3rem;
          padding: 0.26rem 0.28rem 0.24rem 0.28rem;
          //   background-color: #fff;
          width: 6rem;

          &-logo {
            width: 0.36rem;
            height: 0.36rem;
            border-radius: 0.08rem;
            margin-right: 0.16rem;
          }

          &-name {
            font-size: 0.28rem;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: normal;
            color: #333;
            margin-right: 0.02rem;
            margin-bottom: 0.08rem;
          }

          &-btn {
            color: #fff;
            border-radius: 0.32rem;
            height: 0.64rem;
            line-height: 0.64rem;
            background: #fd6f34;
            flex-shrink: 0;
            font-size: 0.24rem;
          }

          &-left {
            &-top {
              //   display: flex;
              //   justify-content: space-between;
              //   align-items: center;
              margin-bottom: 0.24rem;

              &-l {
                display: flex;
                align-items: center;
              }
            }

            &-bottom {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-bottom: 0.2rem;
              border-bottom: 1px dotted #e5e5e5;

              &-item1 {
                // flex-shrink: 0;
                width: 60%;
              }

              //   &-item2 {
              //     width: 30%;
              //   }
              &-item1 {
                .item1-tit {
                  flex-shrink: 0;
                  margin-right: 0.2rem;
                  margin-bottom: 0.2rem;
                  font-size: 0.22rem;
                  font-family: PingFangSC, PingFangSC-Regular;
                  font-weight: normal;
                  color: #7d7f93;
                }

                .item1-text {
                  font-size: 0.36rem;
                  font-family: PingFangSC, PingFangSC-Regular;
                  font-weight: bold;
                  color: #fd6f34;
                }
              }
            }

            &-rate {
              height: 0.6rem;
              padding: 0.18rem 0;
              font-weight: 500;
              color: #aa664a;
            }
          }
        }
      }

      .loan-process-con {
        margin-top: 0.24rem;
        background: #ffffff;
        border-radius: 0.24rem;
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        padding: 0.3rem 0.3rem 0.24rem;

        > h4 {
          font-size: 0.32rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: normal;
          color: #192337;
        }

        ul {
          align-items: stretch;
          margin-top: 0.28rem;
        }

        .loan-process-li {
          > img {
            width: 0.72rem;
            height: 0.72rem;
            border-radius: 50%;
          }

          .icon-img {
            width: 0.3rem;
            height: 0.3rem;
            border-radius: 50%;
            margin-right: 0.06rem;
          }

          h6 {
            font-size: 0.28rem;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: normal;
            color: #192337;
            margin: 0.2rem 0 0.08rem;
          }

          span.green {
            color: #52c41a;
          }

          span.yellow {
            color: #f5a623;
          }

          span.default {
            color: #868e9e;
          }

          p {
            margin-top: 0.08rem;
          }
        }

        .line {
          width: 0;
          padding-top: 0.3rem;

          > img {
            width: 0.84rem;
            height: 0.08rem;
            right: -0.4rem;
            top: 0.3rem;
          }
        }
      }
    }
  }

  .product-elem {
    margin: 0.4rem 0;

    .product-elem-title {
      font-size: 0.28rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: bold;
      color: red;
      display: flex;
      align-items: center;

      .product-elem-gif {
        margin-left: 0.1rem;
        width: 0.42rem;
        height: 0.38rem;
        animation: shake 1s infinite;
      }
    }

    .product-display {
      background: #fff;
      border-radius: 0.24rem;
      margin-top: 0.24rem;
      padding: 0.3rem;

      > div {
        padding-bottom: 0.24rem;
        border-bottom: 0.02rem solid #e6e7ee;
      }

      .product-img {
        width: 0.96rem;
        height: 0.96rem;
        border-radius: 0.2rem;
        margin-right: 0.24rem;
      }

      .product-title {
        font-size: 0.32rem;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: bold;
        color: #111c31;

        .van-tag {
          margin-left: 0.1rem;
          padding: 0.02rem 0.1rem;
          font-size: 0.22rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: normal;
          margin-left: 0.12rem;
        }
      }

      .credit-for-you {
        margin-top: 0.05rem;
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        color: #868e9e;

        > span {
          color: #f03d23;
        }
      }

      .product-display-ul {
        margin: 0.24rem 0 0.4rem;

        p {
          font-size: 0.4rem;
          font-family: AlibabaPuHuiTiR, AlibabaPuHuiTiR-Regular;
          font-weight: normal;
          color: #111c31;
        }

        small {
          font-size: 0.22rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: normal;
          color: #868e9e;
        }
      }

      .originate-loan {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: normal;
        color: #868e9e;

        > span {
          color: #f03d23;
        }
      }
    }
  }

  .product-layer {
    width: calc(100% - 1.52rem);
    padding: 0.36rem 0.46rem;

    > h4 {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: bold;
      color: #111c31;
    }

    > img {
      margin: 0.48rem 0 0.16rem;
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 0.2rem;
    }

    > h5 {
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: bold;
      color: #111c31;
    }

    > p {
      margin: 0.16rem 0 0.3rem;
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      color: #111c31;

      > span {
        color: #fb5e1e;
      }
    }

    > div {
      width: 100%;
      height: 0.96rem;
      line-height: 0.96rem;
      border-radius: 0.48rem;
      font-size: 0.32rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: normal;
    }

    > .btn-now {
      background: $primaryColor;
      color: #ffffff;
    }

    > .btn-not {
      color: #868e9e;
    }
  }

  .wechat-box {
    margin: 0.3rem 0;
    text-align: center;
  }

  .wechat-box .wechat-img {
    width: 0.3rem;
    height: 0.3rem;
    color: #fff;
    animation: moveImage 2s infinite;
    /* 应用动画 */
  }

  .wechat-box .wechat-text {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.3rem 0.2rem;
    font-size: 0.3rem;
    font-weight: 500;
    height: 1rem;
    line-height: 1rem;
    color: transparent;
    text-shadow: -1px -1px 0 #fff, 1px -1px 0 #ff7c0c, -1px 1px 0 #ff7c0c, 1px 1px 0 #ff7c0c;
    border: 1px solid #ff7c0c;
    background: linear-gradient(90deg, #ff7c0c 0%, rgba(255, 194, 0, 1) 100%);
    border-radius: 0.1rem;
  }

  @keyframes moveImage {
    0% {
      transform: translateX(-5px);
    }

    50% {
      transform: translateX(-30px);
    }

    100% {
      transform: translateX(0);
    }
  }
}

.downloadBtnContainer {
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.34rem 0.54rem;
  background-color: #fff;
  box-shadow: 0 -0.2rem 0.1rem 0.06rem rgba(0, 0, 0, 0.03);
}

.download-app-btn {
  font-size: 0.32rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #fff;
  //height: 1.08rem;
  background: linear-gradient(313deg, #ff5612 0%, #fd7539 100%);
  box-shadow: 0px 4px 10px 2px rgba(255, 136, 88, 0.28);
  border: none;
  border-radius: 0.54rem;
  margin: 0.3rem 0;

  .span {
    font-weight: bold;
  }

  + small {
    top: -0.3rem;
    right: 0;
    display: block;
    background: #f03d23;
    border: 0.02rem solid #ffffff;
    border-radius: 2rem 2rem 2rem 0;
    font-size: 0.22rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #ffffff;
    padding: 0.02rem 0.16rem;
  }
}
</style>

<style>
.swiper-pagination {
  text-align: center !important;
}

.swiper-pagination-bullet {
  width: 0.12rem;
  height: 0.12rem;
  background: #ccc;
  opacity: 0.5;
  margin: 0 0.06rem;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  background: #ff4040;
  /* 激活状态颜色 */
}
</style>
